import { render } from "./ShowProductPageView.vue?vue&type=template&id=72a08d3a"
import script from "./ShowProductPageView.vue?vue&type=script&lang=js"
export * from "./ShowProductPageView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__